import React from "react";
import styled from "styled-components";

import {
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel
} from "@material-ui/core";

import countryCodes from "common/countryCodes";

const StyledTextField = styled(TextField)`
    &&& {
        width: 100%;
    }
`;

const CountrySelectForm = styled(FormControl)`
    &&& {
        width: 100%;
    }
`;

const InputContainer = styled.div`
    width: 100%;
    display: flex;
    flex-flow: row;
    align-items: flex-end;
    margin-bottom: 5px;

    >div:nth-child(2) {
        margin-left: 10px;
    }
`;

function AddressForm({
    address,
    required = true,
    onChange
}) {
    const handleChange = fieldName => event => {
        const newAddress = {
            ...address,
            [fieldName]: event.target.value
        };
        const isValid = !required || (newAddress.line1 && newAddress.city && newAddress.postal_code && newAddress.country);

        onChange({
            address: newAddress,
            isValid
        });
    };

    const CustomTextInput = (field, label, required) => (
        <StyledTextField
            autoFocus
            onChange={handleChange(field)}
            variant="standard"
            name={label}
            value={address[field] ?? ""}
            label={`${label}${required ? " (required)" : ""}`}
        />
    );

    return (<>
        <InputContainer>
            {CustomTextInput("line1", "Address line 1", required)}
        </InputContainer>
        <InputContainer>
            {CustomTextInput("line2", "Address line 2", false)}
        </InputContainer>
        <InputContainer>
            {CustomTextInput("city", "City", required)}
            {CustomTextInput("postal_code", "Postal code", required)}
        </InputContainer>
        <InputContainer>
            <CountrySelectForm>
                <InputLabel>Country{required ? " (required)" : ""}</InputLabel>
                <Select
                    value={address.country ?? ""}
                    onChange={handleChange("country")}
                >
                    {Object.entries(countryCodes).map(([code, name]) => <MenuItem key={code} value={code}>{name}</MenuItem>)}
                </Select>
            </CountrySelectForm>
            {CustomTextInput("state", "State", false)}
        </InputContainer>
    </>);
}

export default AddressForm;
